import { Carton, CartonView, CartonProductView } from "../../../models/carton";
import { PurchaseOrder } from "../../../models/purchase.order";

export const convertCartonProductsToCartonsView = (
  purchaseOrder?: PurchaseOrder,
  cartons?: Carton[]
) => {
  if (!cartons || !cartons.length || !purchaseOrder) return [];

  const cartonsView: CartonView[] = [];

  if (cartons && !!cartons.length) {
    for (const carton of cartons) {
      if (!carton.sscc) continue;

      const { cartonProducts } = carton;

      if (cartonProducts && !!cartonProducts.length) {
        const products: CartonProductView[] = [];

        for (const cartonProduct of cartonProducts) {
          if (!cartonProduct) continue;

          products.push({
            ...cartonProduct.product,
            colorDescription:
              cartonProduct?.purchaseOrderProduct?.colorDescription ||
              cartonProduct?.product?.colorDescription,
            itemDescription:
              cartonProduct?.purchaseOrderProduct?.itemDescription ||
              cartonProduct?.product?.itemDescription,
            description:
              cartonProduct?.purchaseOrderProduct?.description ||
              cartonProduct?.product?.description,
            deletedAt: cartonProduct?.purchaseOrderProduct?.deletedAt,
            cartonId: cartonProduct.cartonId,
            quantityInCarton: cartonProduct.quantity,
            poNumber: purchaseOrder.reference,
            weight: cartonProduct.weight,
            cubicVolume: cartonProduct.cubicVolume,
            hsCode: cartonProduct.hsCode,
            construction: cartonProduct.construction,
            lining: cartonProduct.lining,
            category: cartonProduct.category,
            fabric: cartonProduct.fabric,
            composition: cartonProduct.composition,
            length: cartonProduct?.length,
            manufactureDetails: cartonProduct?.manufactureDetails,
            cfsCbm: cartonProduct?.cfsCbm,
            cfsWeight: cartonProduct?.cfsWeight,
            gender: cartonProduct?.gender,
          });
        }

        if (!cartonsView.find((cartonView) => cartonView.id === carton.id))
          cartonsView.push({ ...carton, products } as CartonView);
      }
    }
  }

  return cartonsView;
};

export const getProductSKUWithoutSize = (sku?: string) => {
  if (!sku?.length) return "";
  const skuSplited = sku.split("-");
  const productType: string = skuSplited[0];
  const productColor: string = skuSplited[1];

  return productType + productColor;
};
